//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;
var dot = require("dot");


var $ = require("jquery");

//popup template
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

map.scrollWheelZoom.disable();

//sidebar list template
var markerLayer = L.featureGroup();
var pointData = {};
var listTemplate = require("./_sidebar.html");
ich.addTemplate("list", listTemplate);

var listContainer = $(".list-container");

//create markers from csv lat long data
areaData.forEach(function(feature) {
  var lat = feature.lat;
  var lon = feature.lon;
  var name = feature.name;

  // var marker = L.circleMarker([lat, lon], {
  //   radius: 10,
  //   fillColor: "#55cdfa",
  //   color: "#ffffff",
  //   weight: 1,
  //   opacity: 1,
  //   fillOpacity: 0.7
  // }).addTo(markerLayer);
  var marker = L.marker([lat, lon], {
  icon: L.divIcon({
    className: 'icon',
    iconSize: [20, 20],
    html: '<i class="fa fa-' + feature.icon + '"></i>'
  })
}).addTo(markerLayer);

  marker.bindPopup(ich.popup(feature));
  pointData[name] = marker;

  // if (feature.icon) {
  //   console.log(feature.icon);
  //   $(".icon").append('<i class="fa fa-' + feature.icon + '"></i>')
  // } else {
  //   console.log("no icon");
  // };

});
markerLayer.addTo(map);
map.fitBounds(markerLayer.getBounds());

listContainer.html(ich.list({ list: Object.keys(pointData) }));

//funtion to zoom to markers when clicking on a list item
listContainer.on("click", "li[data-info]", function(){
  var info = this.getAttribute("data-info");
  var layer = pointData[info];
  if (!layer) return;
  layer.openPopup();
  var latlng = layer.getLatLng();
  map.fitBounds([latlng, latlng], {maxZoom: 12, paddingTopLeft:[0,100]});
});
